import { FC } from 'react'
import { useModuleContext } from '../contexts/module'
import SeeArtworkInWallButton from './SeeArtworkInWallButton'
import SeeArtworkVideo from './SeeArtworkVideo'

const SeeOnWallOrVideo: FC<ISeeOnWallOrVideo> = ({ className = '', forceColumn = false }) => {
  const {
    state: { labels, artworkInformation }
  } = useModuleContext()

  const { seeOnWallVisible, videoPosition, id, artworkCleanTitle: cleanTitle, videos } = artworkInformation || {}
  const { isVideoSet } = videos || {}

  return (
    <>
      {(seeOnWallVisible || isVideoSet || artworkInformation?.viewAtFair) && (
        <div className={`${className} d-flex ${forceColumn ? 'flex-column' : 'flex-wrap'}`}>
          {seeOnWallVisible && (
            <SeeArtworkInWallButton
              label={labels?.ArtworkUploader?.seeOnWallLabel}
              cleanTitle={cleanTitle}
              id={id}
              className={`${className} me-6 mb-4`}
            />
          )}
          {isVideoSet && videoPosition !== 0 && <SeeArtworkVideo label={labels?.ShowRoomArtwork?.artworkWatchVideo} />}

        </div>
      )}
    </>
  )
}

interface ISeeOnWallOrVideo {
  className?: string
  forceColumn?: boolean
  onClickFindArtwork?: () => void
}

export default SeeOnWallOrVideo
